// extracted by mini-css-extract-plugin
export default {"container":"EndoDesc_container__+I4jU","content":"EndoDesc_content__RGNxH","title":"EndoDesc_title__7XcYF","text":"EndoDesc_text__3KVmE","par":"EndoDesc_par__ZgVr+"};